




















































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ImageInfo from '@/views/AiiTasks/ImageInfo.vue'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import moment from 'moment'
import { uuid, dateFormat, throttle, download } from '@/utils/util'
import RelationOrders from '@/views/AiiTasks/RelationOrders.vue'
import PendingTrack from '@/views/AiiTasks/PendingTrack.vue'
import Task from '@/web-task'
import Info from '@/views/AiiTasks/Info.vue'
import StaffInfo from '@/components/task/StaffInfo.vue'
import CancelApply from '@/components/task/CancelApply.vue'
import EditInfo from './EditInfo.vue'
import RecordSection from '@/components/task/RecordSection.vue'
import EditTable from './EditTable.vue'

import { idCard } from '@/utils/validator'

import AuditApi from '@/api/audit'
import AreaApi from '@/api/area'
import { debounce } from '@/utils/util'
import { index } from 'mathjs'
import { List } from 'lodash'
const debounceSearch = debounce(300)

@Component({
	name: 'AuditTab',
	components: {
		ImageInfo,
		RelationOrders,
		PendingTrack,
		Info,
		StaffInfo,
		CancelApply,
		RecordSection,
		EditTable,
		EditInfo,
	},
})
export default class AuditTabs extends Vue {
	@Prop()
	public injured!: any

	@Prop()
	public order!: any

	@Prop()
	public boardImageList!: any

	@Prop()
	private show!: any

	@Prop()
	private activeKey!: any

	private taskInfo: any = []
	private staffInfo: any = []
	private accidentInfo: any = false
	private agentInfo: any = false
	private caseDelayInfo: any = {}
	private operatorCancelReasonInfo: any = false
	private operatorCancelHistoryInfo: any = false

	// 可编辑数据
	private editAccidentInfo: any = []
	private editSubAccidentInfo: any = []
	private editRemarkInfo: any = []
	private editInjurdInfo: any = {}
	private editInjuryInfo: any = {}
	private editDiagnoseInfo: any = {}
	private editFamilyInfo: any = false
	private editMajorDiseaseInfo: any = false
	private editAnamnesisInfo: any = false
	private editCaregiversInfo: any = false
	private editWorkInfo: any = false
	private editLivingInfo: any = false
	private editCertificateInfo: any = []
	private editBeneficiaryInfo: any = []

	private partnerStatus: any = {
		checked1: false,
		checked2: false,
		checked3: false,
	}

	private getCancelOrder(index: any) {
		return Math.floor((index + 1) / 2)
	}

	private get mediaInfoMap() {
		const obj: any = {}
		const applyCancels = this.order.applyCancels

		if (applyCancels) {
			const operatorCancel = applyCancels.find(
				(item: any) => item.dataType === 'application'
			)

			if (operatorCancel) {
				const mediaInfoList = operatorCancel.mediaInfoList
				for (const i of mediaInfoList) {
					if (!obj[i.type]) {
						obj[i.type] = []
					}
					obj[i.type].push(i)
				}
			}
		}

		return obj
	}

	@Watch('order', { immediate: true })
	private onOrderChange() {
		const task = new Task({
			propsData: {
				order: this.order,
				injured: this.injured,
				boardImageList: this.boardImageList,
				setting: this.$store.state.setting,
			},
		})
		this.taskInfo = task.getTaskInfo()
		this.taskInfo.span = {
			关节活动度复勘部位: 12,
		}
		this.staffInfo = task.getStaffInfo()

		this.accidentInfo = task.getAccidentInfo()
		this.agentInfo = task.getAgentInfo()
		this.caseDelayInfo = task.getCaseDelayInfo()
		this.operatorCancelReasonInfo = task.getOperatorCancelReasonInfo()
		this.operatorCancelHistoryInfo = task.getOperatorCancelHistoryInfo()

		// 获取可编辑数据格式
		this.editInjurdInfo = task.getEditInjuredInfo()
		// 布局
		this.editInjurdInfo.span = {
			伤者紧急联系人姓名: 12,
			紧急联系人与伤者关系: 12,
			紧急联系人电话: 12,
		}
		// 设置校验规则
		if (this.editInjurdInfo && this.editInjurdInfo.children.length > 0) {
			// 设置身份证级联校验规则
			this.setIdNoRules('editInjurdInfo', this.editInjurdInfo.children[0].value)
		}

		this.editInjuryInfo = task.getEditInjuryInfo()
		this.editInjuryInfo.span = {
			实际就诊医院: 12,
			实际就诊科室: 12,
			首次治疗时间: 12,
			'治疗情况（一级）': 12,
			'治疗情况（二级）': 12,
			'出院日期（未出院填写预估出院时间）': 12,
			'出院日期（未出院无需填写）': 12,
			已产生的医药费: 12,
			是否需要垫付医疗费用: 12,
		}

		this.editAccidentInfo = task.getEditAccidentInfo()
		if (this.editAccidentInfo) {
			this.editAccidentInfo.span = {
				类型: 8,
				出行方式: 8,
				人员位置: 8,
				伤者与被保险人关系: 8,
				伤者事故责任: 8,
				是否上下班途中: 8,
				自身有无违法行为: 8,
				对方有无违法行为: 8,
			}
		}

		this.editSubAccidentInfo = task.getEditSubAccidentInfo()
		if (this.editSubAccidentInfo) {
			this.editSubAccidentInfo.span = {
				地点: 6,
				事故经过: 24,
			}
		}

		this.editRemarkInfo = task.getEditRemarkInfo()
		this.editDiagnoseInfo = task.getEditDiagnoseInfo()
		this.editFamilyInfo = task.getEditFamilyInfo()
		if (this.editFamilyInfo) {
			this.editFamilyInfo.familyDto.partnerStatus != '' &&
				(this.partnerStatus[
					`checked${Number(this.editFamilyInfo.familyDto.partnerStatus) + 1}`
				] = true)
		}
		this.editCaregiversInfo = task.getEditCaregiversInfo()
		if (this.editCaregiversInfo) {
			this.editCaregiversInfo.checkbox = {
				title: '无护理人',
				checked: !this.editCaregiversInfo.caregiversDto.hasCaregivers,
			}
		}
		this.editWorkInfo = task.getEditWorkInfo()
		if (this.editWorkInfo) {
			this.editWorkInfo.checkbox = {
				title: '无工作',
				checked: !this.editWorkInfo.work.hasWork,
			}
		}
		this.editLivingInfo = task.getEditLivingInfo()
		this.editMajorDiseaseInfo = task.getEditMajorDiseaseInfo()
		if (this.editMajorDiseaseInfo) {
			this.editMajorDiseaseInfo.checkbox = {
				title: '无重疾',
				checked: !this.editMajorDiseaseInfo.majorDisease.hasMajorDisease,
			}
		}
		this.editAnamnesisInfo = task.getEditAnamnesisInfo()
		if (this.editAnamnesisInfo) {
			this.editAnamnesisInfo.checkbox = {
				title: '无既往史',
				checked: !this.editAnamnesisInfo.anamnesis.hasAnamnesis,
			}
		}
		this.editCertificateInfo = task.getEditCertificateInfo()
		if (this.editCertificateInfo) {
			this.editCertificateInfo.checkbox = {
				title: '无证件（资格证）',
				checked: !this.editCertificateInfo.certificate.hasCertificate,
			}
		}
		this.editBeneficiaryInfo = task.getEditBeneficiaryInfo()
		if (this.editBeneficiaryInfo) {
			this.editBeneficiaryInfo.checkbox = {
				title: '无监护/受益人',
				checked: !this.editBeneficiaryInfo.beneficiary.hasBeneficiary,
			}
		}
		// 设置校验规则
		// 设置身份证校验规则

		if (
			this.editBeneficiaryInfo &&
			this.editBeneficiaryInfo.children &&
			this.editBeneficiaryInfo.children.length > 0
		) {
			// 设置身份证级联校验规则
			for (
				let index = 0;
				index < this.editBeneficiaryInfo.children.length;
				index++
			) {
				let val = ''
				for (const iterator of this.editBeneficiaryInfo.children[index].list) {
					if (iterator.key == 'certificateType') {
						val = iterator.value
					}
				}
				this.setTableIdNoRules(
					'certificateType',
					index,
					'editBeneficiaryInfo',
					val,
					'certificateNo'
				)
			}
		}
	}

	private get supplyInfo() {
		if (['01', '02', '03'].includes(this.order.orderStatus)) {
			if (this.order.returnFlag === '1') {
				return '（待作业人员重新补录）'
			}
			return '（待作业人员补录）'
		}
		return ''
	}

	@Watch('activeKey')
	private onTabsChange() {
		window.scrollTo(0, 0)
	}

	private zeroUnit(val: any, unit: string = '元') {
		if (val === 0 || val) {
			return val + unit
		} else {
			return
		}
	}

	private dateFormat(start: any, end: any) {
		return dateFormat(start, end)
	}

	private soFarDate(date: any) {
		if (date) {
			if (date < SO_FAR) {
				return moment(this.injured.injuredInfo.leaveDate).format('YYYY-MM-DD')
			} else {
				return '至今'
			}
		} else {
			return
		}
	}
	private onChange() {}

	// 监听表单数据变化（主要处理一些联动表单）
	private selectChange(val: any, key: any, infoStr: string, listTemp: any) {
		console.log(val, key, infoStr)
		if (infoStr == 'editInjurdInfo') {
			if (key == 'idType') {
				this.setIdNoRules('editInjurdInfo', val)
			}
		}
		// 表单的省市区code赋值
		const code = val.split('-')
		if (infoStr == 'editSubAccidentInfo') {
			if (key == 'formatAddress') {
				this.editSubAccidentInfo.children.forEach((item: any) => {
					if (item.key === 'provinceCode') {
						item.value = code[0]
					}
					if (item.key === 'cityCode') {
						item.value = code[1]
					}
					if (item.key === 'areaCode') {
						item.value = code[2]
					}
				})
			}
		}
		if (infoStr == 'editAccidentInfo') {
			if (
				this.isTrue('injuryType', '02', listTemp) &&
				this.isTrue('travelModel', '01', listTemp) &&
				this.isTrue('position', '01', listTemp)
			) {
				this.setHide('insuredRelation', 'select', listTemp)
			} else {
				this.setHide('insuredRelation', 'hide', listTemp)
			}
			if (key == 'injuryType' && val == '02') {
				let travelModellist = this.$store.state.setting.trafficSituationList.filter(
					(item: any) => item.key == '01'
				)
				for (const iterator of listTemp) {
					if (iterator.key == 'travelModel') {
						iterator.selectOption = travelModellist
					}
				}
			}
			if (key == 'injuryType' && val == '01') {
				let travelModellist = this.$store.state.setting.trafficSituationList.filter(
					(item: any) => item.key !== '01'
				)
				for (const iterator of listTemp) {
					if (iterator.key == 'travelModel') {
						iterator.selectOption = travelModellist
					}
				}
			}
		}
	}
	private isTrue(key: any, val: any, list: any) {
		for (const iterator of list) {
			if (iterator.key == key) {
				return iterator.key == key && iterator.value == val
			}
		}
		return false
	}
	private setHide(key: string, type: any, list: any) {
		for (const iterator of list) {
			// 对应值设置
			if (iterator.key == key) {
				iterator.type = type
			}
		}
	}
	// 监听搜索输入（主要处理一些联动表单）
	private tableSelectSearch(val: any, key: any, formNum: any, infoStr: string) {
		console.log(val)
		console.log(key)
		console.log(formNum)
		console.log(infoStr)
		// 诊断名称查询
		if (infoStr == 'editDiagnoseInfo' || infoStr == 'editAnamnesisInfo') {
			if (key == 'clinicalDiagnosis') {
				// 获取诊断名称
				val && this.getClinicalDiagnosis(val, key, formNum, infoStr)
			}
		}
		// 重疾查询
		if (infoStr == 'editMajorDiseaseInfo') {
			if (key == 'diseaseType') {
				// 获取诊断名称列表
				val && this.getDiseaseType(val, key, formNum, infoStr)
			}
		}
		// 工作地区
		if (infoStr == 'editWorkInfo') {
			if (key == 'workAddress') {
				val && this.areaSearch(val, key, formNum, infoStr)
			}
		}
		// 居住经历
		if (infoStr == 'editLivingInfo') {
			if (key == 'homeAddress') {
				val && this.areaSearch(val, key, formNum, infoStr)
			}
		}
		if (infoStr == 'editSubAccidentInfo') {
			if (key == 'formatAddress') {
				val && this.areaSearch(val, key, formNum, infoStr)
			}
		}
	}
	// 监听多行表单数据变化（主要处理一些联动表单）
	private tableSelectChange(
		val: any,
		key: any,
		formNum: any,
		infoStr: string,
		formList: any,
		listTemp: any
	) {
		console.log(val)
		console.log(key)
		console.log(formNum)
		console.log(infoStr)
		const that: any = this
		let info = that[infoStr]
		// 诊断库查询
		if (infoStr == 'editDiagnoseInfo' || infoStr == 'editAnamnesisInfo') {
			// 诊断名称
			if (key == 'clinicalDiagnosis') {
				// 找出选中的诊断名称对象
				let list = []
				for (const iterator of info.children[formNum].list) {
					// 对应值设置
					if (iterator.key == key) {
						list = iterator.selectOption
					}
				}

				const find = list.find((item: any) => item.clinicalDiagnosis == val)
				// 设置损伤部位
				find &&
					this.setTableValue(
						'injuredPartOne',
						formNum,
						infoStr,
						find.injuredPartOne
					)
				// 清空损伤分类
				this.setTableValue('injuredSort', formNum, infoStr, '')
				if (infoStr == 'editDiagnoseInfo') {
					// 清空手术名称
					this.setTableValue('operationDesc', formNum, infoStr, [])
				}
				// 设置损伤分类列表
				find &&
					this.setSelectOptions(
						'injuredSort',
						formNum,
						infoStr,
						find.injuredSorts.map((item: any) => {
							return {
								key: item.diagnosisCode,
								value: item.injuredSort,
								...item,
							}
						})
					)
			}
			if (key == 'injuredSort') {
				// 找出选中的诊断名称对象
				let list = []
				for (const iterator of info.children[formNum].list) {
					// 对应值设置
					if (iterator.key == 'clinicalDiagnosis') {
						list = iterator.selectOption
					}
				}
				// 找出选中的损伤分类对象
				let findList = []
				for (const iterator of list) {
					for (const iterator2 of iterator.injuredSorts) {
						if (iterator2.diagnosisCode == val) {
							findList = iterator2.operationList
						}
					}
				}
				if (infoStr == 'editDiagnoseInfo') {
					// 清空手术名称
					this.setTableValue('operationDesc', formNum, infoStr, [])
					// 设置手术名称列表
					this.setSelectOptions(
						'operationDesc',
						formNum,
						infoStr,
						findList.map((item: any) => {
							return {
								key: item.operationCode + '-',
								value: item.operationName,
								...item,
							}
						})
					)
					// console.log(findList, 'findList')
					// 清空后续治疗项目
					this.setTableValue('followTreatmentDesc', formNum, infoStr, [])
					// 获取后续治疗项目列表
					val && this.getOperation(val, 'followTreatmentDesc', formNum, infoStr)
				}
			}
		}
		// 重疾查询
		if (infoStr == 'editMajorDiseaseInfo') {
			if (key == 'diseaseType') {
				// 清空确诊依据
				this.setTableValue('diagnosisBasis', formNum, infoStr, '')
				// 获取确诊依据列表
				val && this.getDiagnosisBasis(val, 'diagnosisBasis', formNum, infoStr)
			}
		}
		// 家庭成员
		if (infoStr == 'editFamilyInfo') {
			if (key == 'dependType') {
				// 选择父母亲时限制性别
				// 父关系
				if (val == '04') {
					this.setTableRequiredAndEditable('sex', formNum, infoStr, '1', false)
					this.setTableValue('sex', formNum, infoStr, '0')
					this.setTableRequiredAndEditable(
						'dependCount',
						formNum,
						infoStr,
						'1',
						true
					)
				}
				// 母关系
				if (val == '05') {
					this.setTableRequiredAndEditable('sex', formNum, infoStr, '1', false)
					this.setTableValue('sex', formNum, infoStr, '1')
					this.setTableRequiredAndEditable(
						'dependCount',
						formNum,
						infoStr,
						'1',
						true
					)
				}
				// 选择配偶或子女或其他，生育子女数置灰
				if (val != '04' && val != '05') {
					this.setTableRequiredAndEditable(
						'dependCount',
						formNum,
						infoStr,
						'0',
						false
					)
					this.setTableRequiredAndEditable('sex', formNum, infoStr, '1', true)
					this.setTableValue('sex', formNum, infoStr, '')
				}
				if (val == '06') {
					listTemp.forEach((item: any, index: number) => {
						if (index == formNum) {
							item.dependType = '06'
						}
					})
					this.setTableValue('fosterRelation', formNum, infoStr, '子女')
				}
				if (val == '03') {
					this.setTableValue('fosterRelation', formNum, infoStr, '其他')
				}
			}
			if (
				key == 'dependType' ||
				key == 'censusRegisterType' ||
				key == 'dependCount'
			) {
				for (const iterator of formList) {
					if (iterator.key == 'birthday') {
						this.family(iterator.value, formList, formNum, infoStr)
					}
				}
			}
		}
		// 护理人
		if (infoStr == 'editCaregiversInfo') {
			if (key == 'caregiversIdentity') {
				// 选择家属护理，收入/收费为元/月，选择护工护理，收入/收费为元/日
				for (const iterator of info.children[formNum].list) {
					// 对应值设置
					if (iterator.key == 'nursingCost') {
						if (val == '01') {
							iterator.symbol = '元/月'
						} else {
							iterator.symbol = '元/日'
						}
					}
				}
			}
		}
		// 监护人
		if (infoStr == 'editBeneficiaryInfo') {
			if (key == 'certificateType') {
				// 设置身份证校验规则
				this.setTableIdNoRules(
					'certificateType',
					formNum,
					infoStr,
					val,
					'certificateNo'
				)
			}
		}
		// 工作信息
		if (infoStr == 'editWorkInfo') {
			if (key == 'industry') {
				// 清空职业大类
				this.setTableValue('vocation', formNum, infoStr, '')
				val && this.getFirstVocation(val, 'vocation', formNum, infoStr)
			}
			if (key == 'vocation') {
				// 清空职业小类
				this.setTableValue('secondVocation', formNum, infoStr, '')
				val && this.getSecondVocation(val, 'secondVocation', formNum, infoStr)
			}
		}
		// 居住经历
		if (infoStr == 'editLivingInfo') {
			if (key == 'houseNature' && val == '02') {
				this.setTableHide('residencePermit', formNum, infoStr, 'hide')
			} else {
				this.setTableHide('residencePermit', formNum, infoStr, 'select')
			}
		}
	}
	private dropdownVisibleChange(
		val: any,
		key: any,
		formNum: any,
		infoStr: string,
		formList: any
	) {
		if (infoStr == 'editFamilyInfo') {
			if (formNum > 3 && key == 'dependType') {
				let dependentTypeList = this.$store.state.setting.dependentTypeList.filter(
					(item: any) => item.key == '06' || item.key == '03'
				)
				this.setSelectOptions('dependType', formNum, infoStr, dependentTypeList)
			}
		}
	}
	private visibleChange(val: any, key: any, infoStr: string, listTemp: any) {
		if (infoStr == 'editAccidentInfo') {
			for (const iterator of listTemp) {
				if (iterator.key == 'injuryType' && iterator.value == '02') {
					let travelModellist = this.$store.state.setting.trafficSituationList.filter(
						(item: any) => item.key == '01'
					)
					for (const item of listTemp) {
						if (item.key == 'travelModel') {
							item.selectOption = travelModellist
						}
					}
				}
				if (iterator.key == 'injuryType' && iterator.value == '01') {
					let travelModellist = this.$store.state.setting.trafficSituationList.filter(
						(item: any) => item.key !== '01'
					)
					for (const item of listTemp) {
						if (item.key == 'travelModel') {
							item.selectOption = travelModellist
						}
					}
				}
				if (iterator.key == 'travelModel' && iterator.value == '03') {
					let injuryPositionList = this.$store.state.setting.injuryPositionList.filter(
						(item: any) => item.key === '03'
					)
					for (const item of listTemp) {
						if (item.key == 'position') {
							item.selectOption = injuryPositionList
						}
					}
				}
				if (iterator.key == 'travelModel' && iterator.value !== '03') {
					let injuryPositionList = this.$store.state.setting.injuryPositionList.filter(
						(item: any) => item.key !== '03'
					)
					for (const item of listTemp) {
						if (item.key == 'position') {
							item.selectOption = injuryPositionList
						}
					}
				}
			}
		}
	}
	// 单元格显示隐藏
	private setTableHide(
		key: string,
		formNum: number,
		infoStr: string,
		type: any
	) {
		const that: any = this
		let info = that[infoStr]
		for (const iterator of info.children[formNum].list) {
			// 对应值设置
			if (iterator.key == key) {
				iterator.type = type
			}
		}
	}
	private inputChange(
		val: any,
		key: any,
		formNum: any,
		infoStr: string,
		formList: any
	) {
		if (key == 'name' || key == 'sex') {
			for (const iterator of formList) {
				if (iterator.key == 'birthday') {
					this.family(iterator.value, formList, formNum, infoStr)
				}
			}
		}
	}
	private inputChangeInfo(
		val: any,
		key: any,
		infoStr: string,
		listTemp: any,
		obj: any
	) {
		if (infoStr == 'editInjurdInfo') {
			if (key == 'selfPhone' && val.data) {
				this.setRequired('selfPhone', 'editInjurdInfo', '1', listTemp)
			} else if (key == 'selfPhone' && !val.data) {
				this.setRequired('selfPhone', 'editInjurdInfo', '0', listTemp)
			}
			if (key == 'phone' && val.data) {
				this.setRequired('phone', 'editInjurdInfo', '1', listTemp)
			} else if (key == 'phone' && !val.data) {
				this.setRequired('phone', 'editInjurdInfo', '0', listTemp)
			}
			if (key == 'phone0' && val.data) {
				this.setRequired('phone0', 'editInjurdInfo', '1', listTemp)
			} else if (key == 'phone0' && !val.data) {
				this.setRequired('phone0', 'editInjurdInfo', '0', listTemp)
			}
		}
	}
	// 监听多行表单数据变化（主要处理一些联动表单）
	private tableDateChange(
		val: any,
		key: any,
		formNum: any,
		infoStr: string,
		formList: any
	) {
		console.log(val)
		console.log(key)
		console.log(formNum)
		console.log(infoStr)
		// 家庭成员
		if (infoStr == 'editFamilyInfo') {
			// 计算抚养年限
			if (key == 'birthday') {
				let now = moment()
				// 计算被抚养人年龄
				let injuredAge = 0
				if (val) {
					injuredAge = now.diff(val, 'years')
				}
				// 计算抚养年限
				let dependYear: any = ''
				if (injuredAge < 18) {
					dependYear = 18
				} else if (injuredAge >= 18 && injuredAge <= 60) {
					dependYear = 20
				} else if (injuredAge > 60 && injuredAge < 75) {
					dependYear = Number(80 - injuredAge)
				} else if (injuredAge >= 75) {
					dependYear = 5
				}
				this.setTableValue('dependYear', formNum, infoStr, dependYear)
				this.family(val, formList, formNum, infoStr)
			}
		}
	}
	private family(birthday: any, formList: any, formNum: any, infoStr: any) {
		let ages = moment(birthday).format('YYYY-MM-DD')
		let age = this.getAge(ages)
		for (const iterator of formList) {
			if ((iterator.value == '04' || iterator.value == '05') && age < 58) {
				this.setTableRequiredAndEditable('name', formNum, infoStr, '0', true)
				this.setTableRequiredAndEditable(
					'censusRegisterType',
					formNum,
					infoStr,
					'0',
					true
				)
				this.setTableRequiredAndEditable(
					'dependCount',
					formNum,
					infoStr,
					'0',
					true
				)
			}
			if ((iterator.value == '04' || iterator.value == '05') && age >= 58) {
				this.setTableRequiredAndEditable('name', formNum, infoStr, '1', true)
				this.setTableRequiredAndEditable(
					'censusRegisterType',
					formNum,
					infoStr,
					'1',
					true
				)
				this.setTableRequiredAndEditable(
					'dependCount',
					formNum,
					infoStr,
					'1',
					true
				)
			}
			if (iterator.value == '06' && age > 18) {
				this.setTableRequiredAndEditable('name', formNum, infoStr, '0', true)
				this.setTableRequiredAndEditable(
					'censusRegisterType',
					formNum,
					infoStr,
					'0',
					true
				)
			} else if (iterator.value == '06' && age <= 18) {
				this.setTableRequiredAndEditable('name', formNum, infoStr, '1', true)
				this.setTableRequiredAndEditable(
					'censusRegisterType',
					formNum,
					infoStr,
					'1',
					true
				)
			}
		}
	}
	private getAge(birthday: any) {
		var birthdays = new Date(birthday.replace(/-/g, '/'))
		var d = new Date()
		var age =
			d.getFullYear() -
			birthdays.getFullYear() -
			(d.getMonth() < birthdays.getMonth() ||
			(d.getMonth() == birthdays.getMonth() &&
				d.getDate() < birthdays.getDate())
				? 1
				: 0)
		return age
	}
	// 监听多行表单数据变化（主要处理一些联动表单）
	private checkboxChange(
		val: any,
		formNum: any,
		infoStr: string,
		blockNum: any
	) {
		console.log(val)
		console.log(formNum)
		console.log(infoStr)
		// 处理多选框单选
		const that: any = this
		let info = that[infoStr]
		if (blockNum) {
			if (val.target.checked) {
				if (blockNum == 1) {
					this.partnerStatus.checked2 = false
					this.partnerStatus.checked3 = false
				} else if (blockNum == 2) {
					this.partnerStatus.checked1 = false
					this.partnerStatus.checked3 = false
				} else if (blockNum == 3) {
					this.partnerStatus.checked1 = false
					this.partnerStatus.checked2 = false
				}
			}
			if (
				this.partnerStatus.checked1 ||
				this.partnerStatus.checked2 ||
				this.partnerStatus.checked3
			) {
				this.editFamilyInfo.familyDto.partnerStatus = String(blockNum - 1)
			} else {
				this.editFamilyInfo.familyDto.partnerStatus = null
			}
		}
		// 处理选择和不选择之后的禁用问题
		if (blockNum && blockNum == 4) {
			for (const iterator of info.children) {
				if (iterator.dependType == '06') {
					iterator.disabled = val.target.checked
				}
			}
		} else {
			info.children[formNum].disabled = val.target.checked
		}
	}

	private checkIdNo(rule: string, value: string, cb: any) {
		// console.log(value, 'editBeneficiaryInfo')
		if (!value) {
			cb(new Error('请输入身份证号码'))
		} else if (!idCard(value)) {
			cb(new Error('请输入正确的身份证号码'))
		} else {
			cb()
		}
	}

	// 设置证件号校验规则
	public setIdNoRules(infoStr: string, val: any) {
		const that: any = this
		let info = that[infoStr]
		for (const iterator of info.children) {
			// 证件号校验
			if (iterator.key == 'idNo') {
				// 选择身份证时，修改校验规则
				if (val == '01') {
					// 证件类型选择身份证，长度限制18，鼠标失焦后校验身份证号格式，格式不正确提示：请输入正确的身份证号，不清空已填写的信息
					iterator.rules = [
						{
							validator: this.checkIdNo,
							trigger: 'blur',
						},
					]
				} else {
					// 选择其他证件类型无需检验格式，长度30，必填；
					iterator.rules = [
						{
							max: 30,
							message: '证件号不能超过30位',
							trigger: 'blur',
						},
					]
				}
				break
			}
		}
	}

	// 设置多行证件号校验规则
	public setTableIdNoRules(
		key: string,
		formNum: number,
		infoStr: string,
		val: any,
		targetKey: string
	) {
		const that: any = this
		let info = that[infoStr]
		for (const iterator of info.children[formNum].list) {
			// 证件号校验
			if (iterator.key == targetKey) {
				// 选择身份证时，修改校验规则
				if (val == '01') {
					// 证件类型选择身份证，长度限制18，鼠标失焦后校验身份证号格式，格式不正确提示：请输入正确的身份证号，不清空已填写的信息
					iterator.rules = [
						{
							validator: this.checkIdNo,
							trigger: 'blur',
						},
					]
				} else {
					// 选择其他证件类型无需检验格式，长度30，必填；
					iterator.rules = [
						{
							max: 30,
							message: '证件号不能超过30位',
							trigger: 'blur',
						},
					]
				}
				break
			}
		}
	}

	// 所有模块的表单校验
	public validateFormData() {
		let result = true
		const refs: any = this.$refs
		// 校验伤者信息
		result = result && refs.editInjurdInfo.validateFormData()
		// 校验伤者伤情信息
		result = result && refs.editInjuryInfo.validateFormData()
		// 校验诊断库信息
		result = result && refs.editDiagnoseInfo.validateFormData()
		// 校验交通事故信息
		result = result && refs.editAccidentInfo.validateFormData()
		result = result && refs.editSubAccidentInfo.validateFormData()
		// 校验重疾信息
		if (this.editMajorDiseaseInfo) {
			result = result && refs.editMajorDiseaseInfo.validateFormData()
		}
		// 校验既往史信息
		if (this.editAnamnesisInfo) {
			result = result && refs.editAnamnesisInfo.validateFormData()
		}
		// 校验家庭成员信息
		result = result && refs.editFamilyInfo.validateFormData()
		// 校验证件（资格证）信息
		if (this.editCertificateInfo) {
			result = result && refs.editCertificateInfo.validateFormData()
		}
		// 校验护理人信息
		result = result && refs.editCaregiversInfo.validateFormData()
		// 校验监护/受益人信息
		if (this.editBeneficiaryInfo) {
			result = result && refs.editBeneficiaryInfo.validateFormData()
		}
		// 校验工作经历信息
		result = result && refs.editWorkInfo.validateFormData()
		// 校验居住经历信息
		result = result && refs.editLivingInfo.validateFormData()
		return result
	}

	// 获取表单数据
	public getFormData() {
		let formData: any = {}
		const refs: any = this.$refs
		const injured = refs.editInjurdInfo.getFormData()
		const injuredInfo = refs.editInjuryInfo.getFormData()
		// 交通事故信息
		const accidentInfo = refs.editAccidentInfo.getFormData()
		const subAccidentInfo = refs.editSubAccidentInfo.getFormData()
		// 诊断库数据组装
		const diagnoseList =
			this.editDiagnoseInfo.children &&
			this.editDiagnoseInfo.children.map((item: any) => {
				let obj: any = {}
				for (const iterator of item.list) {
					// 诊断编码
					if (iterator.key == 'injuredSort') {
						obj.diagnosisCode = iterator.value
					}
					// 骨折类型
					if (iterator.key == 'fractureType') {
						obj.fractureType = iterator.value
					}
					// 手术编码列表
					if (iterator.key == 'operationDesc') {
						obj.operationList = []
						for (const iterator2 of iterator.selectOption) {
							for (const item of iterator.value) {
								if (iterator2.key == item) {
									obj.operationList.push({
										operationCode: iterator2.key.slice(0, -1),
										operationName: iterator2.value,
									})
								}
							}
						}
					}
					// 后续治疗列表
					if (iterator.key == 'followTreatmentDesc') {
						obj.followTreatmentList = []
						for (const iterator2 of iterator.selectOption) {
							for (const item of iterator.value) {
								if (iterator2.key == item) {
									obj.followTreatmentList.push({
										operationCode: iterator2.key,
										cuteItem: iterator2.value,
									})
								}
							}
						}
					}
				}

				return obj
			})
		// 重疾信息
		const majorDiseaseList =
			this.editMajorDiseaseInfo.children &&
			this.editMajorDiseaseInfo.children.map((item: any) => {
				let obj: any = {}
				for (const iterator of item.list) {
					// 确诊依据
					if (iterator.key == 'diagnosisBasis') {
						obj.diagnosisBasis = iterator.value
					}
					// 确诊依据描述
					if (iterator.key == 'diagnosisBasisDesc') {
						obj.diagnosisBasisDesc = iterator.value
					}
					// 确诊时间
					if (iterator.key == 'diagnosisDate') {
						if (iterator.value) {
							obj.diagnosisDate = iterator.value.format('YYYY-MM-DD')
						}
					}
					// 重疾描述
					if (iterator.key == 'diseaseDesc') {
						obj.diseaseDesc = iterator.value
					}
					// 重疾种类
					if (iterator.key == 'diseaseType') {
						obj.diseaseType = iterator.value
						const find = iterator.selectOption.find(
							(item: any) => item.key == iterator.value
						)
						// 重疾种类描述
						find && (obj.diseaseTypeDesc = find.value)
					}
					// 原发部位
					if (iterator.key == 'primarySite') {
						obj.primarySite = iterator.value
					}
					// 原发部位描述
					if (iterator.key == 'primarySiteDesc') {
						obj.primarySiteDesc = iterator.value
					}
				}

				return obj
			})
		// 既往史信息
		const anamnesisList =
			this.editAnamnesisInfo.children &&
			this.editAnamnesisInfo.children.map((item: any) => {
				let obj: any = {}
				for (const iterator of item.list) {
					// 临床诊断
					if (iterator.key == 'clinicalDiagnosis') {
						obj.clinicalDiagnosis = iterator.value
						const find = iterator.selectOption.find(
							(item: any) => item.key == iterator.value
						)
						// 损伤部位II
						find && (obj.injuredPartTwo = find.injuredPartTwo)
					}
					// 诊断编码
					if (iterator.key == 'injuredSort') {
						obj.diagnosisCode = iterator.value
						const find = iterator.selectOption.find(
							(item: any) => item.key == iterator.value
						)
						// 损伤分类
						find && (obj.injuredSort = find.value)
					}
					// 损伤部位I
					if (iterator.key == 'injuredPartOne') {
						obj.injuredPartOne = iterator.value
					}
				}

				return obj
			})
		// 家庭成员信息
		const familyInfoList =
			this.editFamilyInfo.children &&
			this.editFamilyInfo.children.map((item: any) => {
				let obj: any = {}
				for (const iterator of item.list) {
					// 扶养人姓名
					if (iterator.key == 'name') {
						obj.name = iterator.value
					}
					// 被扶养人类型
					if (iterator.key == 'dependType') {
						obj.dependType = iterator.value
						const find = iterator.selectOption.find(
							(item: any) => item.key == iterator.value
						)
						// 被扶养人类型描述
						find && (obj.typeDesc = find.value)
					}
					// 户籍类型
					if (iterator.key == 'censusRegisterType') {
						obj.censusRegisterType = iterator.value
					}
					// 共同扶养人个数
					if (iterator.key == 'dependCount') {
						obj.dependCount = iterator.value
					}
					// 序号
					if (iterator.key == 'orderNum') {
						obj.orderNum = iterator.value
					}
					// 备注说明，最大 250
					if (iterator.key == 'remark') {
						obj.remark = iterator.value
					}
					// 扶养人关系 （必填）
					if (iterator.key == 'fosterRelation') {
						obj.fosterRelation = iterator.value
					}
					// 性别
					if (iterator.key == 'sex') {
						obj.sex = iterator.value
					}
					// 生日
					if (iterator.key == 'birthday') {
						if (iterator.value) {
							obj.birthday = iterator.value.format('YYYY-MM-DD')
						}
					}
				}

				return obj
			})
		// 证件信息
		const certificateList =
			this.editCertificateInfo.children &&
			this.editCertificateInfo.children.map((item: any) => {
				let obj: any = {}
				for (const iterator of item.list) {
					obj[iterator.key] = iterator.value
				}

				return obj
			})
		// 护理人信息
		const caregiversInfoList =
			this.editCaregiversInfo.children &&
			this.editCaregiversInfo.children.map((item: any, index: number) => {
				let obj: any = {}
				for (const iterator of item.list) {
					// 护理人身份
					if (iterator.key == 'caregiversIdentity') {
						obj.caregiversIdentity = iterator.value
					}
					// 护理人姓名
					if (iterator.key == 'caregiversName') {
						obj.caregiversName = iterator.value
					}
					// 护理费
					if (iterator.key == 'workingPlace') {
						obj.workingPlace = iterator.value
					}
					// 护理费
					if (iterator.key == 'nursingCost') {
						obj.nursingCost = iterator.value
					}
					// 序号（必填）
					if (iterator.key == 'orderNum') {
						obj.orderNum = index + 1
					}
					// 备注
					if (iterator.key == 'remark') {
						obj.remark = iterator.value
					}
					// 时间
					if (iterator.key == 'timeArr') {
						const timeArr = iterator.value
						// 开始时间
						if (timeArr[0]) {
							obj.beginTime = timeArr[0].format('YYYY-MM-DD')
						}
						// 结束时间
						if (timeArr[1]) {
							obj.endTime = timeArr[1].format('YYYY-MM-DD')
						}
					}
				}

				return obj
			})
		// 监护/受益人信息
		const beneficiaryList =
			this.editBeneficiaryInfo.children &&
			this.editBeneficiaryInfo.children.map((item: any) => {
				let obj: any = {}
				for (const iterator of item.list) {
					obj[iterator.key] = iterator.value
				}

				return obj
			})
		// 工作经历信息
		const workInfoList =
			this.editWorkInfo.children &&
			this.editWorkInfo.children.map((item: any, index: number) => {
				let obj: any = {}
				for (const iterator of item.list) {
					// 公司名称
					if (iterator.key == 'companyName') {
						obj.companyName = iterator.value
					}
					// 序号
					if (iterator.key == 'orderNum') {
						obj.orderNum = index
					}
					// 工作地址（省市区）
					if (iterator.key == 'workAddress') {
						const find = iterator.selectOption.find(
							(item: any) => item.key == iterator.value
						)
						// console.log(find)
						if (find) {
							obj.workAddress = find.value
							const arr = find.key.split('-')
							// 省代码
							obj.provinceCode = arr[0]
							// 市代码
							obj.cityCode = arr[1]
							// 区县代码
							obj.areaCode = arr[2]
						}
					}
					// 工作地址
					if (iterator.key == 'workPlace') {
						obj.workPlace = iterator.value
					}

					// 工作发放形式（01现金，02转账）
					if (iterator.key == 'wageType') {
						obj.wageType = iterator.value
					}
					// 工资，最小为0
					if (iterator.key == 'wage') {
						obj.wage = iterator.value
					}
					// 工作岗位
					if (iterator.key == 'jobName') {
						obj.jobName = iterator.value
					}
					// 是否签合同
					if (iterator.key == 'contract') {
						obj.contract = iterator.value
					}
					// 行业
					if (iterator.key == 'industry') {
						obj.industry = iterator.value
						const find = iterator.selectOption.find(
							(item: any) => item.key == iterator.value
						)
						// 行业名称
						find && (obj.industryName = find.value)
					}

					// 职业大类
					if (iterator.key == 'vocation') {
						obj.vocation = iterator.value
						const find = iterator.selectOption.find(
							(item: any) => item.key == iterator.value
						)
						// 一级职业名称
						find && (obj.vocationName = find.value)
					}
					// 职业小类
					if (iterator.key == 'secondVocation') {
						obj.secondVocation = iterator.value
						const find = iterator.selectOption.find(
							(item: any) => item.key == iterator.value
						)
						// 二级职业名称
						find && (obj.secondVocationName = find.value)
					}
					// 时间
					if (iterator.key == 'dateArr') {
						const timeArr = iterator.value
						// 开始时间
						if (timeArr[0]) {
							obj.beginDate = timeArr[0].format('YYYY-MM-DD')
						}
						// 结束时间
						if (timeArr[1]) {
							obj.endDate = timeArr[1].format('YYYY-MM-DD')
						}
					}
					if (iterator.key == 'remark') {
						obj.remark = iterator.value
					}
				}

				return obj
			})
		// 居住经历信息
		const livingInfoList =
			this.editLivingInfo.children &&
			this.editLivingInfo.children.map((item: any) => {
				let obj: any = {}
				for (const iterator of item.list) {
					// 省市区文字组装地址（必填）
					if (iterator.key == 'homeAddress') {
						obj.homeAddress = iterator.value
						const find = iterator.selectOption.find(
							(item: any) => item.key == iterator.value
						)
						if (find) {
							obj.homeAddress = find.value
							const arr = find.key.split('-')
							// 省代码
							obj.provinceCode = arr[0]
							// 市代码
							obj.cityCode = arr[1]
							// 区县代码
							obj.areaCode = arr[2]
						}
					}
					// 居住地址（必填）
					if (iterator.key == 'detailAddress') {
						obj.detailAddress = iterator.value
					}
					// 序号（必填）
					if (iterator.key == 'orderNum') {
						obj.orderNum = index
					}
					// 住房性质
					if (iterator.key == 'houseNature') {
						obj.houseNature = iterator.value
					}
					// 是否有居住证
					if (iterator.key == 'residencePermit') {
						obj.residencePermit = iterator.value
					}
					// 时间
					if (iterator.key == 'dateArr') {
						const timeArr = iterator.value
						// 开始时间
						if (timeArr[0]) {
							obj.beginDate = timeArr[0].format('YYYY-MM-DD')
						}
						// 结束时间
						if (timeArr[1]) {
							obj.endDate = timeArr[1].format('YYYY-MM-DD')
						}
					}
					if (iterator.key == 'remark') {
						obj.remark = iterator.value
					}
				}

				return obj
			})
		// 处理家属电话
		let phoneArr = []
		let emergencyPhoneArr = []
		for (const key in injured) {
			console.log(key)
			if (/^phone[0-9]*$/.test(key)) {
				phoneArr.push(injured[key])
			}
			if (/^emergencyPhone[0-9]*$/.test(key)) {
				emergencyPhoneArr.push(injured[key])
			}
		}
		formData.injured = {
			...injured,
			birthday: injured.birthday ? injured.birthday.format('YYYY-MM-DD') : '',
			phone: phoneArr.join(','),
			emergencyPhone: emergencyPhoneArr.join(','),
		}
		// 取就诊科室name
		if (this.$store.state.setting.paicHospitalsubjectList) {
			for (const iterator of this.$store.state.setting
				.paicHospitalsubjectList) {
				if (iterator.key == injuredInfo.departmentCode) {
					injuredInfo.factVisitingDepartment = iterator.value
				}
			}
		}
		// 处理紧急联系人电话
		formData.injuredInfo = {
			...injuredInfo,
			firstTreatmentTime: injuredInfo.firstTreatmentTime
				? injuredInfo.firstTreatmentTime.format('YYYY-MM-DD HH:mm:ss')
				: '',
			hospitalizedDate: injuredInfo.hospitalizedDate
				? injuredInfo.hospitalizedDate.format('YYYY-MM-DD')
				: '',
			leaveDate: injuredInfo.leaveDate
				? injuredInfo.leaveDate.format('YYYY-MM-DD')
				: '',
			diagnoseList: diagnoseList,
		}
		formData.accidentInfo = {
			...accidentInfo,
			...subAccidentInfo,
			accTime: subAccidentInfo.accTime
				? subAccidentInfo.accTime.format('YYYY-MM-DD HH:mm:ss')
				: '',
		}
		if (this.order.insuranceType !== '01') {
			formData.majorDisease = {
				hasMajorDisease:
					this.editMajorDiseaseInfo.checkbox &&
					this.editMajorDiseaseInfo.checkbox.checked
						? '0'
						: '1',
				majorDiseaseList: majorDiseaseList,
			}
			formData.anamnesis = {
				hasAnamnesis:
					this.editAnamnesisInfo.checkbox &&
					this.editAnamnesisInfo.checkbox.checked
						? '0'
						: '1',
				anamnesisList: anamnesisList,
			}
			formData.certificate = {
				hasCertificate:
					this.editCertificateInfo.checkbox &&
					this.editCertificateInfo.checkbox.checked
						? '0'
						: '1',
				certificateList: certificateList,
			}
			formData.beneficiary = {
				hasBeneficiary:
					this.editBeneficiaryInfo.checkbox &&
					this.editBeneficiaryInfo.checkbox.checked
						? '0'
						: '1',
				beneficiaryList: beneficiaryList,
			}
		}
		formData.familyDto = {
			fatherDied: this.editFamilyInfo.familyDto.fatherDied ? '1' : '0',
			motherDied: this.editFamilyInfo.familyDto.motherDied ? '1' : '0',
			noChildren: this.editFamilyInfo.familyDto.noChildren ? '1' : '0',
			partnerStatus: this.editFamilyInfo.familyDto.partnerStatus,
			noOther: this.editFamilyInfo.familyDto.noOther ? '1' : '0',
			familyInfoList: familyInfoList,
		}
		formData.caregiversDto = {
			hasCaregivers: this.editCaregiversInfo.checkbox.checked ? '0' : '1',
			caregiversInfoList: caregiversInfoList,
		}
		formData.work = {
			hasWork: this.editWorkInfo.checkbox.checked ? '0' : '1',
			workInfoList: workInfoList,
		}
		formData.livingInfoList = [...livingInfoList]
		return formData
	}

	// 获取诊断库
	private getClinicalDiagnosis(
		val: string,
		key: string,
		formNum: number,
		infoStr: string
	) {
		const param = {
			keyword: val,
			insuranceType: this.order.insuranceType,
		}
		debounceSearch(() => {
			AuditApi.getClinicalDiagnosis(param).then((data: any) => {
				if (data.code === 200) {
					const list = data.data

					this.setSelectOptions(
						key,
						formNum,
						infoStr,
						list.map((item: any) => {
							return {
								key: item.clinicalDiagnosis,
								value: item.clinicalDiagnosis,
								...item,
							}
						})
					)
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			})
		})
	}

	// 获取后续治疗库
	private getOperation(
		val: string,
		key: string,
		formNum: number,
		infoStr: string
	) {
		const param = {
			diagnosisCode: val,
		}
		debounceSearch(() => {
			AuditApi.getOperation(param).then((data: any) => {
				if (data.code === 200) {
					const list = data.data
					if (list && list.length) {
						// 无数据则置为必填及可编辑
						this.setTableRequiredAndEditable(
							'followTreatmentDesc',
							formNum,
							infoStr,
							'1',
							true
						)
						// 设置对应数据列表
						this.setSelectOptions(
							key,
							formNum,
							infoStr,
							list.map((item: any) => {
								return {
									key: item.operationCode,
									value: item.cuteItem,
									...item,
								}
							})
						)
					} else {
						// 无数据则置为不必填及不可编辑
						this.setTableRequiredAndEditable(
							'followTreatmentDesc',
							formNum,
							infoStr,
							'0',
							false
						)
					}
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			})
		})
	}

	// 获取重疾种类
	private getDiseaseType(
		val: string,
		key: string,
		formNum: number,
		infoStr: string
	) {
		const param = {
			keyword: val,
		}
		debounceSearch(() => {
			AuditApi.getDiseaseType(param).then((data: any) => {
				if (data.code === 200) {
					const list = data.data

					this.setSelectOptions(
						key,
						formNum,
						infoStr,
						list.map((item: any) => {
							return {
								key: item.diseaseType,
								value: item.diseaseTypeName,
								...item,
							}
						})
					)
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			})
		})
	}

	// 获取确诊依据
	private getDiagnosisBasis(
		val: string,
		key: string,
		formNum: number,
		infoStr: string
	) {
		const param = {
			diseaseType: val,
		}
		debounceSearch(() => {
			AuditApi.getDiagnosisBasis(param).then((data: any) => {
				if (data.code === 200) {
					const list = data.data

					this.setSelectOptions(
						key,
						formNum,
						infoStr,
						list.map((item: any) => {
							return {
								key: item.diagnosisBasis,
								value: item.diagnosisBasisDesc,
								...item,
							}
						})
					)
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			})
		})
	}
	// 获取一级职业类别
	private getFirstVocation(
		val: string,
		key: string,
		formNum: number,
		infoStr: string
	) {
		const param = {
			industry: val,
		}
		debounceSearch(() => {
			AuditApi.getFirstVocation(param).then((data: any) => {
				if (data.code === 200) {
					const list = data.data

					this.setSelectOptions(
						key,
						formNum,
						infoStr,
						list.map((item: any) => {
							return {
								key: item.dicKey,
								value: item.dicValue,
								...item,
							}
						})
					)
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			})
		})
	}
	// 获取二级职业类别
	private getSecondVocation(
		val: string,
		key: string,
		formNum: number,
		infoStr: string
	) {
		const param = {
			parentKey: val,
		}
		debounceSearch(() => {
			AuditApi.getSecondVocation(param).then((data: any) => {
				if (data.code === 200) {
					const list = data.data

					this.setSelectOptions(
						key,
						formNum,
						infoStr,
						list.map((item: any) => {
							return {
								key: item.dicKey,
								value: item.dicValue,
								...item,
							}
						})
					)
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			})
		})
	}
	// 获取地区
	private areaSearch(
		val: string,
		key: string,
		formNum: number,
		infoStr: string
	) {
		return new Promise((resolve: any, reject: any) => {
			debounceSearch(() => {
				AreaApi.searchArea(val)
					.then((res: any) => {
						// 表单
						if (infoStr === 'editSubAccidentInfo') {
							this.setFormSelectOptions(
								key,
								infoStr,
								res.data.map((item: any) => {
									return {
										key:
											item.provCode + '-' + item.cityCode + '-' + item.areaCode,
										value: item.provName + item.cityName + item.areaName,
										...item,
									}
								})
							)
						}
						// 表格
						else {
							this.setSelectOptions(
								key,
								formNum,
								infoStr,
								res.data.map((item: any) => {
									return {
										key:
											item.provCode + '-' + item.cityCode + '-' + item.areaCode,
										value: item.provName + item.cityName + item.areaName,
										...item,
									}
								})
							)
						}
						resolve()
					})
					.finally(() => {
						console.log('获取地区失败')
					})
			})
		})
	}
	private setFormSelectOptions(key: string, infoStr: string, list: any) {
		const that: any = this
		let info = that[infoStr]
		for (const iterator of info.children) {
			// 筛选项设置
			if (iterator.key == key) {
				iterator.selectOption = [...list]
			}
		}
	}
	// 设置多行表单下拉选项
	private setSelectOptions(
		key: string,
		formNum: number,
		infoStr: string,
		list: any
	) {
		const that: any = this
		let info = that[infoStr]
		for (const iterator of info.children[formNum].list) {
			// 筛选项设置
			if (iterator.key == key) {
				iterator.selectOption = [...list]
			}
		}
	}

	// 设置多行表单值
	private setTableValue(
		key: string,
		formNum: number,
		infoStr: string,
		value: any
	) {
		const that: any = this
		let info = that[infoStr]
		for (const iterator of info.children[formNum].list) {
			// 对应值设置
			if (iterator.key == key) {
				iterator.value = value
			}
		}
	}

	// 设置当前项的必填和可编辑
	private setTableRequiredAndEditable(
		key: string,
		formNum: number,
		infoStr: string,
		notNull: string,
		canEdit: boolean
	) {
		const that: any = this
		let info = that[infoStr]
		for (const iterator of info.children[formNum].list) {
			// 对应值设置
			if (iterator.key == key) {
				iterator.notNull = notNull
				iterator.canEdit = canEdit
			}
		}
	}
	// 设置当前项的必填和可编辑
	private setRequired(
		key: string,
		infoStr: string,
		notNull: string,
		list: any
	) {
		for (const iterator of list) {
			// 对应值设置
			if (iterator.key == key) {
				iterator.notNull = notNull
			}
		}
	}
}
